import { render, staticRenderFns } from "./AcceptPage.vue?vue&type=template&id=03df66e4&scoped=true&"
import script from "./AcceptPage.vue?vue&type=script&lang=ts&"
export * from "./AcceptPage.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptPage.vue?vue&type=style&index=0&id=03df66e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03df66e4",
  null
  
)

export default component.exports